import ExportForm from "../common/ExportForm";

const EXPORT_COLUMNS = [
    { key: "requesterId", label: "Requester" },
    { key: "department", label: "Department" },
    { key: "projectId", label: "Project" },
    { key: "startDate", label: "From Date" },
    { key: "endDate", label: "To Date" },
    { key: "hotelName", label: "Hotel Name" },
    { key: "hotelAddress", label: "Hotel Address" },
    { key: "notes", label: "Notes" },
    { key: "status", label: "Status" },
    { key: "approvalTime", label: "Decision Time" },
    { key: "approverId", label: "Approver" },
    { key: "approverNotes", label: "Approver Notes" },
    { key: "void", label: "Void" },
    { key: "paid", label: "Paid" },
    { key: "voidReason", label: "Void Reason" },
    { key: "validateReason", label: "Validate Reason" },
    { key: "notifiedBy", label: "Notified By" },
    { key: "notifiedAt", label: "Notified At" },
    { key: "creatorId", label: "Creator" },
    { key: "createdAt", label: "Created At" },
    { key: "updaterId", label: "Updater" },
    { key: "updatedAt", label: "Updated At" },
];

export default function PerDiemExportForm() {
    return <ExportForm columns = {EXPORT_COLUMNS} />;
}
